import { render, staticRenderFns } from "./privacypolicy.vue?vue&type=template&id=a02d852a"
import script from "./privacypolicy.vue?vue&type=script&lang=js"
export * from "./privacypolicy.vue?vue&type=script&lang=js"
import style0 from "./privacypolicy.vue?vue&type=style&index=0&id=a02d852a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports